import type { SearchEventsResponse } from '../../views/search/graphql/searchEvents';

const searchEventsResponse = ({
  data,
  meta,
  status,
}: SearchEventsResponse): SearchEventsResponse => {
  return {
    __typename: 'SearchEventsResponse',
    data,
    meta,
    status,
  };
};

export default searchEventsResponse;
